<template>
  <el-form-item :label="form.name" :prop="form.model"
               :class="[form.options.required?'label-blue':'']"
                :rules="form.rules"
                :required="form.options.required"
                v-show="!form.options.hidden"
                style="padding-left:10px;line-height:36px;"
  >
  <el-row  style="width:226px">
      <el-col :span="11">
            <el-input-number v-model="input1"
            
              :placeholder="form.options.placeholder"
              :disabled="form.options.disabled"    
               style="width:100%"    
              :type="form.options.dataType"
              :min="0"
               :controls='false' 
              :max="form.options.max"
              :precision="form.options.precision"
             >
    </el-input-number>
      </el-col>
      <el-col :span="2" style="text-align: center;">至</el-col>
      <el-col :span="11">
            <el-input-number v-model="input2"
            
              :placeholder="form.options.placeholder"
              :disabled="form.options.disabled"       
              :type="form.options.dataType"
              style="width:100%"  
              :controls='false' 
              :min="0"
              :max="form.options.max"
              :step="form.options.step"
              :precision="form.options.precision"
              >
                  </el-input-number>
      </el-col>
  
  
 
  
    </el-row>
  </el-form-item>
</template>

<script>
export default {
  name: 'NumToNum',
  data () {
    return {
      key: '',
      formData: {},
      mainValue: '',
      input1:'',
      input2:''
    }
  },
  props: {
    form: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => {
        return {
          name: '',
          prop: '',
          icon: '',
          className: '',
          options: {
            width: "",
            required: false,
            defaultValue: 0,
            min: 0,
            max: 99999999,
            step: 1,
            precision:0,
            disabled: false,
            controlsPosition: "",
            customClass: "",
            labelWidth: 100,
            isLabelWidth: false,
            hidden: false,
            dataBind: true,
            remoteFunc: () => {},
            changeFunc: () => {}
          },
          key: '',
          model: 'value',
          rules: [{}]
        }
      }
    },
    value: Object,
    forms: {
      type: Object,
      default: () => { return {} }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
   model: {
    prop: 'value',
    event: 'input'
  },
  watch: {
    value: {
      immediate: true,
      handler: function (val, oldVal) {
        this.mainValue = val
      }
    },
    input1(val,oldVal){
        this.value[this.form.model][0] = val.toString()
    },
    input2 (val, oldVal) {
        this.value[this.form.model][1] = val.toString()
    }
  },
  methods: {
    onInput () {
      let that = this
      that.$emit('input', that.value, that.form.model)
      if (typeof that.form.options.changeFunc === 'function') { // 判断是否存在数据改变事件
        that.form.options.changeFunc(that.value[that.form.model], that, that.forms)
      }
    },
    setValue (val) {
      this.mainValue = val
    }
  },
  created () {
    let that = this
    that.key = that.form.key
    if (that.form.hasOwnProperty('options')) {
      that.value[that.form.model] = that.value[that.form.model] || this.form['options']['defaultValue'] || ''
    }
  },
  mounted () {
    let that = this
    that.$emit('init', that.key, that)
  },
  computed: {
    inputDisable () {
      return this.disabled || this.form.options.disabled
    }
  }
}
</script>

<style scoped>
  .el-input-number{
    width:229.49px;
  }
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Customize/NumToNum.vue"
}
</vue-filename-injector>
